import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/appclient';
import { MaterialModule } from '@sdbn/appclient';
import { ListExportDocumentComponent } from './component/list-export-document.component';
import { StructureNodeSelectionModule } from 'src/tmc-yard/components/structure-node-selection/structure-node-selection.module';


@NgModule({
  declarations: [
    ListExportDocumentComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,
    MaterialModule,
    MatTableModule,
    MatSortModule,
    ReactiveFormsModule,
    FormsModule,
    StructureNodeSelectionModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ]
})
export class ListExportDocumentsModule { }
